import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import { visibleDocs } from '@/content/docs/registry'
import { useFeatureStore } from '@/stores/featureStore'
import { tourFor, type PageTour } from '@/services/tour/tourModel'

/**
 * The tour of the page the person is on, from the page guides they may see (SA-1315, spec §5):
 * a guide behind a feature the deployment lacks has none. Null on a page with no tour.
 */
export function usePageTour(): PageTour | null {
  const { pathname } = useLocation()
  // `features` is replaced when the manifest loads, so the tour is looked for again then.
  const features = useFeatureStore((s) => s.features)
  const isEnabled = useFeatureStore((s) => s.isEnabled)
  return useMemo(
    () => tourFor(pathname, visibleDocs({ authenticated: true, isEnabled })),
    // eslint-disable-next-line react-hooks/exhaustive-deps -- `features` stands for what isEnabled reads
    [pathname, features, isEnabled]
  )
}
